module.exports = __webpack_public_path__ + "static/media/dashboard-eye-sidebar.c833f25d.svg";